import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupBy',
  pure: false,
})
export class GroupByPipe implements PipeTransform {

  transform(list: any[], property: string): any[]  {
    if (!list) {
      return [];
    }
    const groupedCollection = list.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }
      return previous;
    }, {});

    const result = Object.keys(groupedCollection).map(key => ({ key , value: groupedCollection[key] }));
    return result;
  }

}
